import { zeroAddress } from 'viem'
import type { ChainConfig } from '../types'
import { getQuickNodeRpcUrl } from '../utils/getQuickNodeRpcUrl'

export const MONAD = {
  name: 'monad',
  chainId: 143,
  averageBlockTimeSeconds: 0.4,
  explorerUrl: 'https://monadscan.com/',
  nativeAsset: {
    assetAddress: zeroAddress,
    decimals: 18,
    name: 'MON',
    symbol: 'MON',
  },
  slip44: 268435779,
  wrappedNativeAsset: '0x3bd359c1119da7da1d913d1c4d2b7c461115433a',
  blockscoutApiUrl: undefined,
  etherscanSupported: true,
  publicRpcUrls: [
    'https://rpc.monad.xyz',
    'https://rpc1.monad.xyz',
    'https://rpc3.monad.xyz',
    'https://rpc-mainnet.monadinfra.com',
  ],
  getPrivateRpcUrls: () => {
    const monad: string[] = []
    process.env.ROUTEME_API_KEY && monad.push(`https://lb.routeme.sh/rpc/143/${process.env.ROUTEME_API_KEY}`)
    const quickNodeUrl = getQuickNodeRpcUrl('monad')
    quickNodeUrl && monad.push(quickNodeUrl)
    process.env.INFURA_API_KEY && monad.push(`https://monad-mainnet.infura.io/v3/${process.env.INFURA_API_KEY}`)
    process.env.ALCHEMY_API_KEY && monad.push(`https://monad-mainnet.g.alchemy.com/v2/${process.env.ALCHEMY_API_KEY}`)
    return monad
  },
} as const satisfies ChainConfig
